"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
exports.__esModule = true;
var BaseModel_1 = require("./BaseModel");
var CustomerRequest;
(function (CustomerRequest) {
    var Create = (function (_super) {
        __extends(Create, _super);
        function Create() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            _this.facebookId = undefined;
            _this.socialId = undefined;
            _this.serviceProvider = undefined;
            return _this;
        }
        return Create;
    }(BaseModel_1["default"]));
    CustomerRequest.Create = Create;
    var Update = (function (_super) {
        __extends(Update, _super);
        function Update() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.address = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Update;
    }(BaseModel_1["default"]));
    CustomerRequest.Update = Update;
})(CustomerRequest = exports.CustomerRequest || (exports.CustomerRequest = {}));
var CustomerResponse;
(function (CustomerResponse) {
    var Customer = (function (_super) {
        __extends(Customer, _super);
        function Customer() {
            var _this = _super !== null && _super.apply(this, arguments) || this;
            _this.id = undefined;
            _this.name = undefined;
            _this.lastName = undefined;
            _this.email = undefined;
            _this.userRoleId = undefined;
            _this.address = undefined;
            _this.number = undefined;
            _this.apt = undefined;
            _this.city = undefined;
            _this.departament = undefined;
            _this.zip = undefined;
            _this.phone = undefined;
            _this.active = undefined;
            return _this;
        }
        return Customer;
    }(BaseModel_1["default"]));
    CustomerResponse.Customer = Customer;
    var All = (function (_super) {
        __extends(All, _super);
        function All(objects, length, offset, pagination) {
            if (length === void 0) { length = 0; }
            if (offset === void 0) { offset = 0; }
            if (pagination === void 0) { pagination = 100; }
            var _this = _super.call(this) || this;
            _this.objects = undefined;
            _this.length = 0;
            _this.offset = 0;
            _this.pagination = 100;
            _this.objects = objects;
            _this.length = length;
            _this.offset = offset;
            _this.pagination = pagination;
            return _this;
        }
        return All;
    }(BaseModel_1["default"]));
    CustomerResponse.All = All;
})(CustomerResponse = exports.CustomerResponse || (exports.CustomerResponse = {}));



//////////////////
// WEBPACK FOOTER
// ../model/dist/models/customer.js
// module id = ../model/dist/models/customer.js
// module chunks = main